<template>

  <div>
    <headNav></headNav>
    <div>
      <div class="visible-xs-block" style="height: 50px;"></div>
      <div id="carousel-example-generic" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
          <li data-target="#carousel-example-generic" data-slide-to="0" class="active"></li>
          <li data-target="#carousel-example-generic" data-slide-to="1"></li>
          <li data-target="#carousel-example-generic" data-slide-to="2"></li>
        </ol>


        <div class="carousel-inner">
          <div class="item active">
            <img src="../assets/s6.png" alt="...">

          </div>
          <div class="item">
            <img src="../assets/s5.png" alt="...">
          </div>
          <div class="item">
            <img src="../assets/s11.png" alt="...">
          </div>
        </div>
      </div>
    </div>


    <div class="row text-center" style="margin-top: 20px;padding-bottom: 20px;">
      <div class="col-md-5">
        <img style="margin-bottom: 5px;" src="../assets/chairman.jpg" class="img-responsive">
        <span style="color: #44444;font-size: 16px;">河南威盾保安服务有限公司董事长<span style="font-weight: bold;">韦存山</span></span>
      </div>
      <div class="col-md-7 text-left">
        <h3 class="text-center">公司简介
          <br>
          <small style="margin-top: 5px;">company profile</small>
        </h3>
        <h4 style="font-size: 16px;margin-top: 40px;margin-bottom: 60px;">
          公司以诚信、和谐、规范、创新为理念，按高起点、高标准、多方位的方针，坚持走集团化，专业化的发展路子。</h4>
        <hr style="border-top: 2px solid rgba(2, 80, 170, 0.8);">
        <h4 style="font-size: 16px;margin-top: 60px;margin-bottom: 20px;">
          河南威盾保安服务有限公司成立于 2010 年 12 月 14 日，是省公安厅豫公通【 2010 】 291 号文件批准成立，工商行政管理局登记注册的一家专业保安公司。注册资金5100万，公司规模现有8000余人
        </h4>
        <router-link to="/gsjj">
          <button type="button" class="btn btn btn-info pull-right">more</button>
        </router-link>
      </div>
    </div>

    <div class="text-center" style="padding: 40px  0px 64px  0px;background-color: #E9ecef;">
      <h3>信息详情
        <br>
        <small style="margin-top: 5px;">Message Details</small>
      </h3>
      <hr style="border-top: 1px solid #d1d4d7; margin-top: 30px;margin-bottom: 30px;">
      <div class="row  message text-left visible-md-block visible-lg-block">
        <div class=" col-md-3  ">
          <div class="messageColor">
            <h3>800+</h3>
            <h4>我们的客户</h4>
            <h5>our clients</h5>
          </div>
        </div>
        <div class="col-md-3 ">
          <div class="messageColor">
            <h3>200+</h3>
            <h4>合作订单</h4>
            <h5>Work orders</h5>
          </div>
        </div>
        <div class="col-md-3 ">
          <div class="messageColor">
            <h3>2</h3>
            <h4>训练基地 </h4>
            <h5>training center</h5>
          </div>
        </div>
        <div class="col-md-3  ">
          <div class="messageColor">
            <h3>30</h3>
            <h4>分公司管理</h4>
            <h5>filiale management</h5>
          </div>
        </div>
        <div class="col-md-3 ">
          <div class="messageColor">
            <h3>8000+</h3>
            <h4>我们的员工</h4>
            <h5>our staff</h5>
          </div>
        </div>


      </div>

      <!--移动端-->
      <div class="row  message text-center visible-xs-block">
        <div class=" col-xs-12">
          <div class="messageColor">
            <h3>800+</h3>
            <h4>我们的客户</h4>
            <h5>our clients</h5>
          </div>
        </div>
        <div class="col-xs-12" style="margin-top: 10px;">
          <div class="messageColor">
            <h3>200+</h3>
            <h4>合作订单</h4>
            <h5>Work orders</h5>
          </div>
        </div>
        <div class="col-xs-12 " style="margin-top: 10px;">
          <div class="messageColor">
            <h3>2</h3>
            <h4>训练基地 </h4>
            <h5>training center</h5>
          </div>
        </div>
        <div class="col-xs-12  " style="margin-top: 10px;">
          <div class="messageColor">
            <h3>30</h3>
            <h4>分公司管理</h4>
            <h5>filiale management</h5>
          </div>
        </div>
        <div class="col-xs-12 " style="margin-top: 10px;">
          <div class="messageColor">
            <h3>8000+</h3>
            <h4>我们的员工</h4>
            <h5>our staff</h5>
          </div>
        </div>


      </div>



    </div>


    <div class="text-center" style="padding: 40px 0px 0px 0px;">
      <h3>主营范围
        <br>
        <small style="margin-top: 5px;">Main business scope</small>
      </h3>
      <hr style="border-top: 1px solid #d1d4d7; margin-top: 30px;margin-bottom: 30px;">
      <div class="row  message text-left visible-md-block visible-lg-block">
        <div class="col-md-3">
          <div class="mainBusinessScope">
            <img src="../assets/main1.png" class="img-responsive">
            <div>
              <h4>人防</h4>
              <p>
                派驻保安人员；提供门卫、巡逻、守卫等专业安保人员服务。
              </p>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="mainBusinessScope">
            <img src="../assets/main2.png" class="img-responsive">
            <div>
              <h4>技防</h4>
              <p>
                为客户提供安防工程安装、设计、施工、维修、器材开发与销售等多项服务。
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mainBusinessScope">
            <img src="../assets/main3.png" class="img-responsive">
            <div>
              <h4>护卫</h4>
              <p>
                为大型社会活动、文艺演出、体育比赛、展览销售及明星要人提供特保服务。
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mainBusinessScope">
            <img src="../assets/main4.png" class="img-responsive">
            <div>
              <h4>培训</h4>
              <p>
                对保安人员进行常规性的军事化、正规化、规范化的学习和训练。
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mainBusinessScope">
            <img src="../assets/main5.png" class="img-responsive">
            <div>
              <h4>咨询</h4>
              <p>
                为客户提供安全风险评估、安全 预警方案、安防技术开发等安全咨 询服务
              </p>
            </div>
          </div>
        </div>
      </div>

      <!--移动端-->
      <div class="row  message text-left visible-xs-block">
        <div class="col-xs-12">
          <div class="mainBusinessScope">
            <img src="../assets/main1.png" class="img-responsive">
            <div>
              <h4>人防</h4>
              <p>
                派驻保安人员；提供门卫、巡逻、守卫等专业安保人员服务。
              </p>
            </div>
          </div>
        </div>

        <div class="col-xs-12">
          <div class="mainBusinessScope">
            <img src="../assets/main2.png" class="img-responsive">
            <div>
              <h4>技防</h4>
              <p>
                为客户提供安防工程安装、设计、施工、维修、器材开发与销售等多项服务。
              </p>
            </div>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="mainBusinessScope">
            <img src="../assets/main3.png" class="img-responsive">
            <div>
              <h4>护卫</h4>
              <p>
                为大型社会活动、文艺演出、体育比赛、展览销售及明星要人提供特保服务。
              </p>
            </div>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="mainBusinessScope">
            <img src="../assets/main4.png" class="img-responsive">
            <div>
              <h4>培训</h4>
              <p>
                对保安人员进行常规性的军事化、正规化、规范化的学习和训练。
              </p>
            </div>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="mainBusinessScope">
            <img src="../assets/main5.png" class="img-responsive">
            <div>
              <h4>咨询</h4>
              <p>
                为客户提供安全风险评估、安全 预警方案、安防技术开发等安全咨 询服务
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>



    <div class="row text-left" style="margin-top: 50px;">
      <div class="col-md-6">
        <h3>最新动态
          <br>
          <small style="margin-top: 5px;">Recent news</small>
        </h3>
        <ul class="list-unstyled" style="margin-top: 20px;">
          <li v-for="(news,i) in result">
            <router-link :to="{path:'/xwxq',query:{id:news.id}}">
              <div class="row">
                <div class="col-md-2 col-xs-2 text-center newsSizeDiv">
                  <img class="newsSize" src="../assets/point.png">
                </div>
                <div class="col-md-10 col-xs-10">
                  <h4 class="newsH4">{{news.title}}</h4>
                  <h5>{{news.create_time}}</h5>
                </div>
              </div>
            </router-link>
          </li>



        </ul>
      </div>

      <div class="col-md-6">
        <h3>项目分类
          <br>
          <small style="margin-top: 5px;">project classification</small>
        </h3>
        <div class="row">
          <div class="col-md-6">
            <ul class="list-unstyled probjetUl">
              <li>
                <div style="background-color: #343a40;">
                  <img class="img-responsive" src="../assets/project1.png" />
                  <div class="probjetDiv">
                    <h5 class="probjetH5">教育-文化</h5>
                  </div>
                </div>
              </li>
              <li>
                <div style="background-color: #343a40;">
                  <img class="img-responsive" src="../assets/project3.png" />
                  <div class="probjetDiv">
                    <h5 class="probjetH5">商业-金融</h5>
                  </div>
                </div>
              </li>
              <li>
                <div style="background-color: #343a40;">
                  <img class="img-responsive" src="../assets/project5.png" />
                  <div class="probjetDiv">
                    <h5 class="probjetH5">民航-交通</h5>
                  </div>
                </div>
              </li>

            </ul>
          </div>
          <div class="col-md-6">
            <ul class="list-unstyled probjetUl">
              <li>
                <div style="background-color: #343a40;">
                  <img class="img-responsive" src="../assets/project2.png" />
                  <div class="probjetDiv">
                    <h5 class="probjetH5">景区-景点</h5>
                  </div>
                </div>
              </li>
              <li>
                <div style="background-color: #343a40;">
                  <img class="img-responsive" src="../assets/project4.png" />
                  <div class="probjetDiv">
                    <h5 class="probjetH5">教育-能源</h5>
                  </div>
                </div>
              </li>
              <li>
                <div style="background-color: #343a40;">
                  <img class="img-responsive" src="../assets/project6.png" />
                  <div class="probjetDiv">
                    <h5 class="probjetH5">责任-公益</h5>
                  </div>
                </div>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>


    <Base>
    </Base>
  </div>

</template>
<script>
  $(function() {
    $('.carousel').carousel({
      interval: 5000 // in milliseconds
    });
  });

  export default {
    data() {
      return {
        result: [ ],





      }
    },
    mounted() {
      this.getnews();
    },
    methods: {
      getnews() {
        console.log(this.HOST + '/wd/journalism/contentByType');
        // this.$axios({
        //               url: this.HOST + '调用的接口',
        //               method: '方法：如post、get',
        //               headers: {
        //              //请求头，可以将token放在这里
        //                 'key':value
        //               },
        //               params: {
        //              //需要传过去的参数
        //                 'key':value
        //               }
        //             }).then(res => {
        //                 //res为后端传回来的数据
        //             })
        this.$axios({
          method: 'get',
          url: this.HOST + '/wd/journalism/contentByType',
          data: {
            type: 1,
          }
        }).then(res => {
          console.log(res.data.data)
          this.result = res.data.data;

        })
      }

    }




  }
</script>

<style>
  .mainBusinessScope div {
    height: 190px;
    padding: 20px;
  }

  .newsH4 {
    margin-top: 0px;
  }

  .probjetUl li {
    margin-top: 10px;
  }

  .probjetDiv {
    padding: 10px;
  }

  .probjetH5 {
    margin-top: 0px;
    margin-bottom: 0px;
    color: #FFFFFF;
    font-size: 16px;
  }

  .newsSizeDiv {
    padding-top: 10px;
  }

  .newsSize {
    width: 15px;
    height: 15px;
  }

  .message .col-md-3 {
    width: 20%;
  }

  .messageColor {
    background-color: rgb(255, 255, 255);
    padding: 15px;
  }

  .mainBusinessScope {
    background-color: #FFFFFF;
    border: 1px solid #e6e9eb;
    border-radius: 3px;
  }

  .mainBusinessScope h4 {
    font-weight: bold;
  }

  .mainBusinessScope p {
    font-size: 16px;
  }

  .row {
    margin-left: 0px;
    margin-right: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue